<template>
    <div class="placeholder-container">
      <div class="placeholder-content">
        <font-awesome-icon :icon="icon" class="placeholder-icon" />
        <h2>{{ title }}</h2>
        <p>{{ message || 'Fitur ini sedang dalam pengembangan. Silakan kembali lagi nanti.' }}</p>
        <div class="coming-soon">
          <span>Coming Soon</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PlaceholderPage',
    props: {
      title: {
        type: String,
        required: true
      },
      icon: {
        type: Array,
        default: () => ['fas', 'tools']
      },
      message: {
        type: String,
        default: ''
      }
    }
  }
  </script>
  
  <style scoped>
  .placeholder-container {
    max-width: 800px;
    margin: 40px auto;
    padding: 40px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .placeholder-icon {
    font-size: 4rem;
    color: #3b82f6;
    margin-bottom: 20px;
  }
  
  .placeholder-content h2 {
    font-size: 1.8rem;
    color: #333;
    margin-bottom: 15px;
  }
  
  .placeholder-content p {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 25px;
    line-height: 1.5;
  }
  
  .coming-soon {
    display: inline-block;
    background-color: #3b82f6;
    color: white;
    padding: 8px 16px;
    border-radius: 50px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-size: 0.8rem;
    animation: pulse 2s infinite;
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.05);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  </style>